// extracted by mini-css-extract-plugin
export default {"infoText":"Auth_infoText__sfcbP","separationContainer":"Auth_separationContainer__PbHov","footerLinks":"Auth_footerLinks__xuR90","ssoContainer":"Auth_ssoContainer__74Yt3"};